import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import { PURL_SAFE_HELP_MESSAGE } from "Constants";
import { PackageFormData } from "Types";
import SelectCreateAutocomplete from "../SelectCreateAutocomplete/SelectCreateAutocomplete";

type PackageStepProps = {
  packages: string[];
};

const SelectPackage = ({ packages }: PackageStepProps): React.JSX.Element => {
  const formMethods = useFormContext<PackageFormData>();
  const { setFocus, formState } = formMethods;

  const hasExistingPackages = packages.length > 0;
  const [isCreatingMode, setIsCreatingMode] = useState(!hasExistingPackages);

  useEffect(() => {
    if (isCreatingMode && hasExistingPackages) {
      setFocus("package_description");
    }
  }, [isCreatingMode, setFocus, hasExistingPackages]);

  return (
    <Dialog.Section>
      <Dialog.Section.Title>
        {hasExistingPackages
          ? "Select package or create new one"
          : "Create package"}
      </Dialog.Section.Title>
      <Dialog.Section.Description>
        {hasExistingPackages
          ? "If the package you are searching for doesn't exist, an option to create it will appear."
          : "Type in package name and short description to create a package."}
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <SelectCreateAutocomplete
          id="package-autocomplete"
          name="package_name"
          label="Package name"
          options={packages}
          isCreatingMode={isCreatingMode}
          onModeChange={(isCreatingMode: boolean) =>
            setIsCreatingMode(isCreatingMode)
          }
          helperText={isCreatingMode ? PURL_SAFE_HELP_MESSAGE : undefined}
          placeholder={!isCreatingMode ? "Search packages" : undefined}
        />
        {isCreatingMode ? (
          <Form.TextArea
            name="package_description"
            label="Short description"
            id="package-description"
            errors={formState.errors}
          />
        ) : (
          <></>
        )}
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default SelectPackage;
